<template>
  <dx-modal :value="show" title="Cancelar lote" size="sm" id="modal-batch-cancel"
            :closable="!saving" @input="close()">
    <div class="stenci-group stenci-error">
      <p>
        O cancelamento devolve {{ batch.quantity === 1 ? 'a guia' : `as ${batch.quantity} guias` }}
        para "Aberta", cancela o título e os repasses ainda não pagos e apaga as glosas
        registradas. O número {{ batch.number }} não é reaproveitado.
      </p>
    </div>
    <div class="form-group" :class="{'has-error': $v.form.reason.$error}">
      <label class="form-label" for="batch-cancel-reason">Motivo</label>
      <textarea id="batch-cancel-reason" class="form-input" rows="3" maxlength="500"
                v-model="form.reason" @blur="$v.form.reason.$touch()"></textarea>
      <template v-if="$v.form.reason.$error">
        <div class="form-input-hint" v-if="!$v.form.reason.required">Campo obrigatório</div>
        <div class="form-input-hint" v-else>Descreva o motivo com ao menos duas palavras</div>
      </template>
    </div>
    <template slot="footer">
      <button class="btn btn-error btn-icon btn-icon-left mr-1"
              :class="{loading: saving}" :disabled="saving" @click="save">
        <fa-icon :icon="['fal', 'ban']"/>Cancelar lote
      </button>
      <button class="btn" :disabled="saving" @click="close()">Voltar</button>
    </template>
  </dx-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { minWords } from '@/data/validators';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    batch: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      saving: false,
      form: {
        reason: '',
      },
    };
  },
  validations() {
    return {
      form: {
        reason: { required, minWords: minWords(2) },
      },
    };
  },
  methods: {
    save() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      this.saving = true;
      this.$http.post(`/billing-batches/${this.batch.id}/cancel`, { reason: this.form.reason.trim() })
        .then(({ data }) => {
          this.$toast.success('Lote cancelado. As guias voltaram para \'Aberta\'.');
          this.$emit('canceled', data);
          this.$emit('close', true);
        })
        .catch((e) => {
          this.$toast.error(e);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    close(canceled = false) {
      if (this.saving) return;
      this.$emit('close', canceled);
    },
  },
};
</script>

<style lang="scss">
@import "../batch.scss";
</style>
